var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-map',{ref:"mapControl",staticStyle:{"height":"600px","width":"100%"},attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":{
      minZoom: 1.5,
      zoomSnap:0.5,
    attributionControl:false,
    worldCopyJump:true}}},[(_vm.show)?_c('l-geo-json',{ref:"geojson",attrs:{"geojson":_vm.geojson,"options":_vm.options,"options-style":_vm.styleFunction}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }